var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4432",
  "data-name": "Group 4432",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 41.774,
  height: 36.552,
  viewBox: "0 0 41.774 36.552"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x2: 1,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#26b975"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#26b99a"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Union_6",
  "data-name": "Union 6",
  d: "M34.691,36.552V27.094l7.083,9.459Zm-31.222,0A3.566,3.566,0,0,1,0,32.9V1.828A1.783,1.783,0,0,1,1.735,0H31.222a3.566,3.566,0,0,1,3.469,3.655v32.9Z",
  transform: "translate(0 0)",
  fill: "url(#linear-gradient)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Path_393",
  "data-name": "Path 393",
  transform: "translate(5.296 5.852)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_642",
  "data-name": "Path 642",
  d: "M1.545,0H21.624a3.089,3.089,0,0,1,3.089,3.089V24.713H3.089A3.089,3.089,0,0,1,0,21.624V1.545A1.545,1.545,0,0,1,1.545,0Z",
  transform: "translate(0 0)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_643",
  "data-name": "Path 643",
  d: "M1.765,1.765V21.624a1.325,1.325,0,0,0,1.324,1.324H22.948V3.089a1.325,1.325,0,0,0-1.324-1.324H1.765M1.545,0H21.624a3.089,3.089,0,0,1,3.089,3.089V24.713H3.089A3.089,3.089,0,0,1,0,21.624V1.545A1.545,1.545,0,0,1,1.545,0Z",
  transform: "translate(0 0)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/WingMenLogo.5cce8a4f.svg";
export { SvgComponent as ReactComponent };